import { type ProductCompare } from '@/types'
import clsx from 'clsx'
import { useRouter } from 'next/router'
import { useEffect, type Dispatch, type SetStateAction } from 'react'
import DrawBottom from '../DrawBottom'
import { FormButton } from '../Form'
import { CompareClose } from '../Icon/CompareClose'
import ImageOptimize from '../ImageOptimize'

export interface ComparePopup {
  className?: string
  open: boolean
  setProductCompares: (newValue: ProductCompare[]) => void
  productCompares: ProductCompare[]
  setIsOpenComparePopup: Dispatch<SetStateAction<boolean>>
  setIsOpenAddComparePopup: Dispatch<SetStateAction<boolean>>
  type?: string
}

export function ComparePopup({
  open = false,
  productCompares,
  setProductCompares,
  setIsOpenComparePopup,
  setIsOpenAddComparePopup,
}: ComparePopup) {
  const router = useRouter()
  const isActive = productCompares.filter(e => e._id).length > 1

  useEffect(() => {
    setIsOpenAddComparePopup(false)
    setIsOpenComparePopup(false)
  },[])
  return (
    <DrawBottom
      mainClassName='!h-[30vh] !m-0 !p-0'
      open={open}
      onClose={() => true}
      title={''}
      scroll={true}
      hideClose={true}
    >
      <div className='comparePopupContent h-full'>
        <div className='grid h-full grid-cols-3 gap-x-[10px] pt-1 py-[15px] border-b border-gray-400'>
          {productCompares.length > 0 &&
            productCompares.map((e, index) => (
              <div
                key={`productCompare_${index}`}
                onClick={() => {
                  if (!e._id) {
                    setIsOpenAddComparePopup(true)
                    setIsOpenComparePopup(false)
                  }
                }}
                className={`${
                  index < 2 && 'border-r border-gray-400'
                } relative flex cursor-pointer flex-col items-center justify-center text-center pr-[5px]`}
              >
                {e._id && (
                  <span
                    onClick={() => {
                      return setProductCompares(
                        productCompares
                          .map(f => (f._id === e._id ? {} : f))
                          .sort((a, b) => {
                            if (
                              Object.keys(a).length === 0 &&
                              Object.keys(b).length === 0
                            ) {
                              return 0
                            }
                            if (Object.keys(a).length === 0) return 1
                            if (Object.keys(b).length === 0) return -1
                            return 0
                          })
                      )
                    }}
                    className='absolute right-[5px] top-[5px]'
                  >
                    <CompareClose></CompareClose>
                  </span>
                )}
                <ImageOptimize
                  className={`${!e._id && 'mb-2'} cursor-pointer`}
                  width={e.image ? 70 : 50}
                  height={e.image ? 70 : 50}
                  quality={100}
                  src={e.image || '/../../assets/images/compare-default.svg'}
                  alt={e.name || ''}
                  priority={true}
                />
                <span className='cursor-pointer text-textSmall text-dark-1000'>
                  {e.name || 'Thêm sản phẩm'}
                </span>
              </div>
            ))}
        </div>
        <div className='flex h-full items-center justify-center'>
          <FormButton
            type='button'
            className={clsx(
              'h-[40px] w-[186px] text-Label font-semibold uppercase text-dark-400 bg-white'
            )}
            onClick={() => {
              setIsOpenComparePopup(false)
            }}
          >
            Thu gọn
          </FormButton>
          <FormButton
            type='button'
            className={clsx(
              'h-[40px] w-[186px] text-Label font-semibold uppercase text-white',
              isActive ? 'bg-blue-1100' : 'bg-gray-400'
            )}
            disabled={!isActive}
            onClick={() => {
              setIsOpenComparePopup(false)
              return router.push(
                `/compare?products=${productCompares
                  .map(e => e.link)
                  .filter(Boolean)
                  .join('-vs-')}`
              )
            }}
          >
            So sánh ngay
          </FormButton>
        </div>
      </div>
    </DrawBottom>
  )
}

export default ComparePopup
